module.exports = __webpack_public_path__ + "media/images/arrow_back_blue-56743e8f.png";